<template>
  <v-dialog
    v-if="images.length > 0"
    v-model="lightBoxDialog"
    persistent
    content-class="v-lightbox"
    max-width="calc(90% - 200px)"
    max-height="calc(90% - 200px)"
    elevation="0"
    @click:outside="onClickOutside"
    @keydown="onKeydown"
  >
    <v-btn icon x-large @click="toggleLightBoxDialog" class="v-lightbox__close">
      <v-icon large color="bhWhite">bhi-close</v-icon>
    </v-btn>
    <v-btn
      icon
      x-large
      @click="prevImage"
      class="v-lightbox__navigation v-lightbox__navigation--prev"
      :class="isPrevImage ? '' : 'v-lightbox__navigation--disabled'"
    >
      <v-icon large color="bhWhite">bhi-arrow-left</v-icon>
    </v-btn>
    <v-btn
      icon
      x-large
      @click="nextImage"
      class="v-lightbox__navigation v-lightbox__navigation--next"
      :class="isNextImage ? '' : 'v-lightbox__navigation--disabled'"
    >
      <v-icon large color="bhWhite">bhi-arrow-right</v-icon>
    </v-btn>
    <div class="v-lightbox__content">
      <div class="v-lightbox__image--wrap">
        <v-img
          :src="images[activeImageIndex]"
          :lazy-src="images[activeImageIndex]"
          :key="activeImageIndex"
          contain
          min-height="200"
          min-width="200"
          class="v-lightbox__image"
        >
          <template v-slot:placeholder>
            <v-row
              class="fill-height ma-0"
              align="center"
              justify="center"
            >
              <v-progress-circular
                size="52"
                indeterminate
                color="bhWhite"
              ></v-progress-circular>
            </v-row>
          </template>
        </v-img>
      </div>
    </div>
  </v-dialog>
</template>

<script>
export default {
  name: "LightBox",
  props: {
    images: {
      type: Array,
      default: () => []
    }
  },
  data: () => ({
    activeImageIndex: 0,
    lightBoxDialog: false
  }),
  computed: {
    isNextImage() {
      return !!this.images[this.activeImageIndex + 1];
    },
    isPrevImage() {
      return !!this.images[this.activeImageIndex - 1];
    }
  },
  methods: {
    onClickOutside() {
      this.toggleLightBoxDialog()
    },
    onKeydown(key) {
      if (key.code === "Escape" && key.isTrusted) this.toggleLightBoxDialog()
    },
    nextImage() {
      if (this.isNextImage) {
        this.activeImageIndex++;
      }
    },
    prevImage() {
      if (this.isPrevImage) {
        this.activeImageIndex--;
      }
    },
    openLightBoxImage(index) {
      if (index !== undefined && Number.isInteger(index)) {
        this.activeImageIndex = index;
      }

      this.lightBoxDialog = true;
    },
    toggleLightBoxDialog () {
      this.lightBoxDialog = !this.lightBoxDialog;

      if (!this.lightBoxDialog) {
        this.activeImageIndex = 0;
      }
    }
  }
};
</script>
<style lang="scss">
@import "@/styles/variables.scss";

.v-lightbox {
  box-shadow: none !important;

  &__close {
    position: fixed;
    top: 20px;
    right: 20px;
  }

  &__content {
    display: flex;
    align-items: center;
    justify-content: center;
  }

  &__image {
    max-width: 80vw;
    max-height: 90vh;

    &--wrap {
      display: inline-block;
    }
  }

  &__navigation {
    position: fixed;
    top: calc(50% - 26px);

    &--next {
      right: 20px;
    }

    &--prev {
      left: 20px;
    }

    &--disabled {
      opacity: 0.5;
    }
  }
}
</style>
